import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';

export const Container = styled.div<{ isLocked: boolean }>`
  position: relative;
  pointer-events: ${({ isLocked }) => (isLocked ? 'none' : 'auto')};
  background-color: ${({ isLocked }) =>
    isLocked ? `${Colors.PrimaryLight}1A` : 'transparent'};
  border-radius: 4px;

  & > *:not(:last-child) {
    opacity: ${({ isLocked }) => (isLocked ? 0.8 : 1)};
  }
`;

export const TooltipBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background-color: ${Colors.PrimaryDark};
  color: ${Colors.White};
  padding: 12px 16px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
`;

export const SailsImage = styled.img`
  max-width: 200px;
`;

export const UpgradeLink = styled.a`
  color: ${Colors.Secondary};
  text-decoration: underline;
  pointer-events: auto;
  cursor: pointer;

  &:hover {
    color: ${Colors.PrimaryLight};
  }
`;
